import React from 'react';

interface ISouthIconProps {
	size?: string;
	className?: string;
}

export const South = ({ size = '24', className }: ISouthIconProps) => {
	return (
		<svg width={size} height={size} viewBox="0 0 24 25" fill="none" className={`${className}`}>
			<path
				d="M11.332 2.77669L2.27669 11.832C1.90777 12.2009 1.90777 12.7991 2.27669 13.168L11.332 22.2233C11.7009 22.5922 12.2991 22.5922 12.668 22.2233L21.7233 13.168C22.0922 12.7991 22.0922 12.2009 21.7233 11.832L12.668 2.77669C12.2991 2.40777 11.7009 2.40777 11.332 2.77669Z"
				stroke="#3D3D3D"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.5 9H12C11.6022 9 11.2206 9.1475 10.9393 9.41005C10.658 9.6726 10.5 10.0287 10.5 10.4C10.5 12.5 13.5 12.5 13.5 14.6C13.5 14.9713 13.342 15.3274 13.0607 15.5899C12.7794 15.8525 12.3978 16 12 16H10.5"
				stroke="#3D3D3D"
				strokeLinecap="square"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
